import React from 'react';
import SearchForWallet from '../components/LittleWalletNew/SearchForWallet';
import '../assets/css/little_wallet_new.css';


const LittleWalletNew = () => {

  return (
    <div>
      <SearchForWallet />
    </div>
  );
};

export default LittleWalletNew;


/** WEBPACK FOOTER **
 ** ./src/containers/LittleWalletNew.js
 **/